import { render, staticRenderFns } from "./ds-kpi-card.vue?vue&type=template&id=3316056c&scoped=true"
import script from "./ds-kpi-card.vue?vue&type=script&lang=js"
export * from "./ds-kpi-card.vue?vue&type=script&lang=js"
import style0 from "./ds-kpi-card.vue?vue&type=style&index=0&id=3316056c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316056c",
  null
  
)

export default component.exports